import { ASTRONAUT_SINGLE, ASTRONAUT_GROUP } from "../_media/assets";
import { BOOK_SESSION, JOIN_GROUP } from "../_utils/links";

const serviceDescriptions = [
  {
    id: "individual",
    name: "Individual or Couple Sessions",
    description:
      "Collaborate with a trained professional Individually or with a partner to uncover parts of yourself and heal from trauma. Our confidential and personalized sessions are designed to help you achieve your unique goals and create a brighter future.",
    image: ASTRONAUT_SINGLE,
    link: BOOK_SESSION
  },
  {
    id: "group",
    name: "Group sessions",
    description:
      "A group setting can help you gain clarity and perspective on your own life as you begin to cultivate relations with others. Members go through a vetting process and are placed based on their unique experience and goals as it relates to the group’s overall dynamnic.",
    image: ASTRONAUT_GROUP,
    link: JOIN_GROUP
  },
];

export default serviceDescriptions;
